import 'react-multi-carousel/lib/styles.css';
import { Card, CardMedia, CardContent, Typography, Box, Grid } from '@mui/material';
import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { fetchLearningTools, getLearningTools } from '../../redux/actions/content';
import { useDispatch, useSelector } from 'react-redux';
import { Colors, ResourceStatus, ResourcePlacement, GroupStatus } from '../../enums/enums';
import { fetchUserGroups, getUserGroups } from '../../redux/actions/groups';

const useStyles = makeStyles({
  root: {
    width: '340px',
    height: '270px',
    marginLeft: '20px',
    marginBottom: '30px',
    transition: 'box-shadow 0.3s ease-in-out',
    '&:hover': {
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
    }
  }
});

export default function ResourcesGrid(userObject) {
  const userClientId = userObject?.user?.clientId;
  const userId = localStorage.getItem('LOCELLE:USER');
  const classes = useStyles();
  const dispatch = useDispatch();
  const learningTools = useSelector(getLearningTools);
  const userGroups = useSelector(getUserGroups);

  useEffect(() => {
    dispatch(fetchLearningTools());
    dispatch(fetchUserGroups(userId));
  }, [userId]);

  // Get user's cohort IDs from their active groups only
  const userCohortIds = userGroups?.filter((group) => group.status === GroupStatus.Active)?.map((group) => group.id);

  const activeHomepageLearningTools = learningTools?.filter(
    (lt) => lt.status === ResourceStatus.Active && lt.placement === ResourcePlacement.Homepage
  );
  const learningToolsWithRestrictions = activeHomepageLearningTools?.filter((lt) => {
    // Check client restrictions
    const clientMatch = lt.clientIds ? lt?.clientIds?.includes(userClientId) : true;
    
    // Check cohort restrictions
    const cohortMatch = lt.cohortIds && lt.cohortIds.length > 0 
      ? userCohortIds?.some(cohortId => lt.cohortIds.includes(cohortId))
      : true;
    
    return clientMatch && cohortMatch;
  });

  return (
      <Box>
        <Grid container spacing={1}>
          {learningToolsWithRestrictions?.map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item?.id}>
                <a target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'black' }} href={item?.azureUrl}>
                  <Card className={classes.root}>
                    <CardMedia sx={{ height: '180px' }} component="img" image={item?.thumbnailUrl} />
                    <CardContent>
                      <Typography textAlign="center" variant="h6" component="div" sx={{ color: Colors.TextElevated }}>
                        {item.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </a>
              </Grid>
          ))}
        </Grid>
      </Box>
  );
}